import React from 'react';

const IconInvert = () => (
  <svg xmlns="http://www.w3.org/2000/svg">
    <g id="Exploded_Icons" data-name="Exploded Icons">
      <path
        id="_Compound_Path_"
        data-name="<Compound Path>"
        fill="var(--primary-color)"
        d="M86.65,37.45,75.54,26.34,64.42,37.45a15.71,15.71,0,1,0,22.23,0ZM75.54,60.35a11.78,11.78,0,0,1-8.33-20.11l8.33-8.35Z"></path>
    </g>
  </svg>
);

export default IconInvert;
